import $ from 'jquery';
import { initInterframe } from './Interframe';
import { iframeUrl } from '../constants/cystackConfig';

export const createIframe = () => {
    const container = $('#cystack-iframe-container');
    const $iframe = $(`<iframe id="cystack-iframe" src="${iframeUrl}"></iframe>`);
    initInterframe($iframe[0]);
    container.append($iframe);

    handleResize()
    $( window ).resize(() => {
        handleResize()
    });
};

function handleResize() {
    const container = $('#cystack-iframe-container');
    const menuHeight = $('#adminmenuwrap').height()
    const htmlHeight = $('body').height()
    if (menuHeight > htmlHeight && Number.isInteger(menuHeight)) {
        container.attr('style', `height: ${menuHeight}px !important`);
    } else {
        container.removeAttr('style')
    }
}
